import { createNamespacedHelpers } from 'vuex'
import { USER_PUT_USER } from '@/store/modules/user/action-types'
import { loadingHandler } from '@/utils/ui'
import { devLog } from '@/utils'
import pageFiltersMixin from '@/mixins/pageFiltersMixin'

const storeUser = createNamespacedHelpers('user')
export default {
  PERSISTENCE_KEY: null,
  mixins: [pageFiltersMixin],
  computed: {
    ...storeUser.mapState({
      utilisateur: 'utilisateur'
    }),
    pageConfig () {
      const { PERSISTENCE_KEY } = this.$options
      const { pagesConfig = {} } = this.utilisateur
      const { filtersPreset, config } = PERSISTENCE_KEY
        ? pagesConfig[PERSISTENCE_KEY] || {}
        : {}
      return {
        filtersPreset: filtersPreset || [],
        config: config || this.defaultConfig
      }
    },
    defaultConfig () {
      const def = this._getFavoritePreset()
      return def
        ? _.cloneDeep(def)
        : {}
    }
  },
  methods: {
    ...storeUser.mapActions({
      putUser: USER_PUT_USER
    }),
    _getFavoritePreset () {
      const { filtersPreset } = this.pageConfig
      return filtersPreset.find((f) => f.favorite)
    },
    _defaultFilters () {
      const def = this._getFavoritePreset()
      return def
        ? def.filters
        : {}
    },
    async onPageConfigChange (pageConfig) {
      const { PERSISTENCE_KEY } = this.$options
      if (!PERSISTENCE_KEY) {
        return devLog('PERSISTENCE_KEY is null')
      }
      const { pagesConfig = {} } = this.utilisateur
      await loadingHandler(() => this.putUser({
        pagesConfig: {
          ...pagesConfig,
          [PERSISTENCE_KEY]: {
            filtersPreset: [],
            ...pageConfig
          }
        }
      }))
    },
    onSaveFilterPreset (filtersPreset = []) {
      return this.onPageConfigChange({
        ...this.pageConfig,
        filtersPreset
      })
    },
    onSaveConfig ({ filters, ...config }) {
      return this.onPageConfigChange({
        ...this.pageConfig,
        config
      })
    }
  }
}
